import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
export const useScrollYCoord = () => {
    const [scrollDirection, setScrollDirection] = useState(0);
    const [prevOffset, setPrevOffset] = useState(0);
    const toggleScrollDirection = () => {
        const { scrollY } = window;
        if (scrollY === 0) {
            setScrollDirection(0);
        }
        else {
            setScrollDirection(scrollY);
        }
    };
    useEffect(() => {
        window.addEventListener("scroll", toggleScrollDirection);
        return () => {
            window.removeEventListener("scroll", toggleScrollDirection);
        };
    });
    return scrollDirection;
};
export const useScrollDirection = () => {
    const upString = "up";
    const downString = "down";
    const [scrollDirection, setScrollDirection] = useState(null);
    const [prevOffset, setPrevOffset] = useState(0);
    const toggleScrollDirection = () => {
        const { scrollY } = window;
        if (scrollY === 0) {
            setScrollDirection(null);
        }
        if (scrollY > prevOffset) {
            setScrollDirection(downString);
        }
        else if (scrollY < prevOffset) {
            setScrollDirection(upString);
        }
        setPrevOffset(scrollY);
    };
    useEffect(() => {
        window.addEventListener("scroll", toggleScrollDirection);
        return () => {
            window.removeEventListener("scroll", toggleScrollDirection);
        };
    });
    return scrollDirection;
};
export const useScreenWidth = () => {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const handleResize = () => {
        const { innerWidth } = window;
        setScreenWidth(innerWidth);
    };
    useEffect(() => {
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return screenWidth;
};
export const useAccardionsOpenSubscription = (quantity, bags_info) => {
    const [accordionsOpened, setAccordionsOpened] = useState([]);
    const [PWQuantityDiff, setPWQuantityDiff] = useState(false);
    const [HWQuantityDiff, setHWQuantityDiff] = useState(false);
    const [applyAll, setApplyAll] = useState(false);
    const [initId, setInitId] = useState("");
    const originalCart = useSelector((state) => state.originalUserCart);
    const newCart = useSelector((state) => state.userCart);
    const loading = useSelector((state) => state.components.loading);
    useEffect(() => {
        const PWOldQuantity = Number(originalCart?.find((item) => item.item_type === "preworkout")?.quantity);
        const PWNewQuantity = Number(newCart.find((item) => item.item_type === "preworkout")?.quantity);
        if (PWOldQuantity < PWNewQuantity) {
            const num = PWNewQuantity - PWOldQuantity;
            const firstArr = new Array(Math.abs(Number(quantity) - num)).fill(false);
            const secondArr = new Array(num).fill(true);
            const initArr = firstArr.concat(secondArr);
            setAccordionsOpened(initArr);
        }
    }, [PWQuantityDiff]);
    useEffect(() => {
        const HWOldQuantity = Number(originalCart?.find((item) => item.item_type === "hydration")?.quantity);
        const HWNewQuantity = Number(newCart.find((item) => item.item_type === "hydration")?.quantity);
        if (HWOldQuantity < HWNewQuantity) {
            const num = HWNewQuantity - HWOldQuantity;
            const firstArr = new Array(Math.abs(Number(quantity) - num)).fill(false);
            const secondArr = new Array(num).fill(true);
            const initArr = firstArr.concat(secondArr);
            setAccordionsOpened(initArr);
        }
    }, [HWQuantityDiff]);
    useEffect(() => {
        const initArr = new Array(bags_info.length).fill(false);
        initArr.unshift(true);
        initArr.pop();
        setAccordionsOpened(initArr);
        const PWOldQuantity = originalCart?.find((item) => item.item_type === "preworkout")?.quantity;
        const PWNewQuantity = newCart.find((item) => item.item_type === "preworkout")?.quantity;
        setPWQuantityDiff(PWOldQuantity !== PWNewQuantity);
        const HWOldQuantity = originalCart?.find((item) => item.item_type === "hydration")?.quantity;
        const HWNewQuantity = newCart.find((item) => item.item_type === "hydration")?.quantity;
        setHWQuantityDiff(HWOldQuantity !== HWNewQuantity);
        setInitId(bags_info[0].id);
    }, []);
    useEffect(() => {
        setApplyAll(bags_info[0].applyAll);
        if (bags_info[0].applyAll !== applyAll && bags_info[0].applyAll === false) {
            const initArr = new Array(bags_info.length).fill(true);
            setAccordionsOpened(initArr);
        }
        else if (bags_info[0].applyAll === true) {
            const firstArr = new Array(1).fill(true);
            const secondArr = new Array(bags_info.length - 1).fill(false);
            const initArr = firstArr.concat(secondArr);
            setAccordionsOpened(initArr);
        }
        else if (loading === true) {
            const firstArr = new Array(1).fill(true);
            const secondArr = new Array(bags_info.length - 1).fill(false);
            const initArr = firstArr.concat(secondArr);
            setAccordionsOpened(initArr);
        }
        else if (bags_info[0].id === initId) {
            const firstArr = new Array(1).fill(true);
            const secondArr = new Array(bags_info.length - 1).fill(false);
            const initArr = firstArr.concat(secondArr);
            setAccordionsOpened(initArr);
        }
    }, [bags_info[0].applyAll, loading, bags_info[0].id]);
    const toggleAccordions = (opened, i) => {
        const initArr = new Array(bags_info.length).fill(false);
        if (opened) {
            setAccordionsOpened(initArr);
        }
        else {
            initArr.splice(i, 1, true);
            setAccordionsOpened(initArr);
        }
    };
    return [accordionsOpened, toggleAccordions];
};
export const useAccardionsOpenCustomization = (quantity, bags_info) => {
    const [initialQuantity, setInitialQuantity] = useState(0);
    const [accordionsOpened, setAccordionsOpened] = useState([]);
    const [applyAll, setApplyAll] = useState(false);
    const loading = useSelector((state) => state.components.loading);
    useEffect(() => {
        if (initialQuantity < Number(quantity)) {
            const firstArr = new Array(initialQuantity).fill(true);
            const secondArr = new Array(Number(quantity) - initialQuantity).fill(false);
            const initArr = firstArr.concat(secondArr);
            setAccordionsOpened(initArr);
        }
    }, [quantity]);
    useEffect(() => {
        setInitialQuantity(Number(quantity));
    }, []);
    useEffect(() => {
        if (typeof bags_info === "undefined") {
            const initArr = new Array(1).fill(true);
            setAccordionsOpened(initArr);
        }
        else {
            const initArr = new Array(bags_info.length).fill(false);
            initArr.unshift(true);
            initArr.pop();
            setAccordionsOpened(initArr);
        }
    }, []);
    if (typeof bags_info !== "undefined") {
        useEffect(() => {
            setApplyAll(bags_info[0].applyAll);
            if (bags_info[0].applyAll !== applyAll && bags_info[0].applyAll === false) {
                const initArr = new Array(bags_info.length).fill(true);
                setAccordionsOpened(initArr);
            }
            else if (bags_info[0].applyAll === true) {
                const firstArr = new Array(1).fill(true);
                const secondArr = new Array(bags_info.length - 1).fill(false);
                const initArr = firstArr.concat(secondArr);
                setAccordionsOpened(initArr);
            }
            else if (loading === true) {
                const firstArr = new Array(1).fill(true);
                const secondArr = new Array(bags_info.length - 1).fill(false);
                const initArr = firstArr.concat(secondArr);
                setAccordionsOpened(initArr);
            }
        }, [bags_info[0].applyAll, loading]);
    }
    const toggleAccordions = (opened, i) => {
        const initArr = new Array(Number(quantity)).fill(false);
        if (opened) {
            setAccordionsOpened(initArr);
        }
        else {
            initArr.splice(i, 1, true);
            setAccordionsOpened(initArr);
        }
    };
    return [accordionsOpened, toggleAccordions];
};
export const useIsScrolling = () => {
    const [isScrolling, setIsScrolling] = useState(false);
    const onScrollStop = () => {
        let isScroll;
        window.addEventListener("scroll", (e) => {
            setIsScrolling(true);
            clearTimeout(isScroll);
            isScroll = setTimeout(() => {
                setIsScrolling(false);
            }, 500);
        }, false);
    };
    useEffect(() => {
        onScrollStop();
        return () => {
            window.removeEventListener("scroll", onScrollStop);
        };
    }, []);
    return isScrolling;
};
